import type { Board } from 'chessboard/model/board/types';
import type { KeyedArrow, RawKeyedArrow } from 'chessboard/plugins/arrows/config/types';
import { KeyModifiers } from 'chessboard/model/dom/types';

/**
 * Create a keyed highlight object.
 */
export function createKeyedArrow({
  options,
  rawArrow,
}: {
  options: Board.Options;
  rawArrow: RawKeyedArrow;
}): KeyedArrow {
  const {
    data: { color, keyPressed, from, opacity, to },
    key,
    type,
  } = rawArrow;

  return {
    data: {
      color: getArrowColor(keyPressed, options) ?? color ?? options.arrowColors.default,
      from,
      opacity: opacity ?? options.analysisHighlightOpacity,
      to,
    },
    key,
    type,
  };
}

/**
 * Get the arrow color from the key pressed.
 */
function getArrowColor(keyPressed: KeyModifiers, options: Board.Options) {
  const { arrowColors } = options;

  switch (keyPressed) {
    case KeyModifiers.Alt:
      return arrowColors.alt;
    case KeyModifiers.Ctrl:
      return arrowColors.ctrl;
    case KeyModifiers.Shift:
      return arrowColors.shift;
    case KeyModifiers.None:
      return arrowColors.default;
    default:
      return undefined;
  }
}
